module.exports = __webpack_public_path__ + "static/img/about_bg.6afecff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_bg.png
// module id = 3g0+
// module chunks = 2